import { PublishedResults } from '../../../components/results/shared/PublishedResults';

export default function ParentViewExam() {
  return <PublishedResults assessmentType="exam" audience="parent" />;
}
